package dairy.mynotes.reusablecomponents

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun DeleteIcon(
    modifier: Modifier,
    contentDescription: String
) {
    Icon(
        imageVector = Icons.Filled.Delete,
        contentDescription = contentDescription,
        modifier = modifier
    )
}
